/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const publicDataRemovalRequestDataStatusSchema = z.enum([
	'pending',
	'notified',
	'approved',
	'rejected',
	'completed',
	'expired',
])

export type PublicDataRemovalRequestDataStatusSchema = z.infer<typeof publicDataRemovalRequestDataStatusSchema>
